import backofficeService from '@/api/backoffice.js'
import publicService from '../../../api/public'
export default {
  getall(params) {
    return backofficeService.Api().get('masjidImage', {
        params
      })
      .then(response => response.data)
      .catch((error) => {
        throw error
      })
  },

  getAllPublicImages(params) {
    return publicService.Api().get('/public/masjidImage', {
        params
      })
      .then(response => response.data)
      .catch((error) => {
        throw error
      })
  },

  create(data) {
    return backofficeService.Api().post('masjidImage', data)
      .then(response => {
        console.log('response', response)
        return response.data
      })
      .catch((error) => {
        throw error
      })
  },
  /**
   * Update specific category
   * @param {*} id
   * @param {*} data
   */
  update(id, data) {
    return backofficeService.Api().put(`masjidImage/${id}`, data)
      .then(response => response.data)
      .catch((error) => {
        throw error
      })
  },
  /**
   * Delete ad
   * @param {} id
   * @param {*} params
   */
  delete(id, params) {
    return backofficeService.Api().delete(`masjidImage/${id}`, {
        params
      })
      .then(response => response.data)
      .catch((error) => {
        throw error
      })
  },
}